import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SDM18HCN from './SDM18HCN';
import SDM18SP2 from './SDM18SP2';
import SDM18MVR from './SDM18MVR';
import SDM19DEE from './SDM19DEE';
import SDM19DE2 from './SDM19DE2';
import SDM19STM from './SDM19STM';
import BasicForm from './BasicForm';

class FHEProductDetail extends PureComponent {
    static propTypes = {
        moduleType: PropTypes.string.isRequired
    };

    static defaultProps = {};

    render() {
        const { moduleType } = this.props;

        const detailContentByType = {
            SDM18MVR: () => <SDM18MVR {...this.props} />,
            SDM18HCN: () => <SDM18HCN {...this.props} />,
            SDM18SP2: () => <SDM18SP2 {...this.props} />,
            SDM19DEE: () => <SDM19DEE {...this.props} />,
            SDM19DE2: () => <SDM19DE2 {...this.props} />,
            SDM19STM: () => <SDM19STM {...this.props} />,
            default: () => null
        };
        return <BasicForm {...this.props}>{(detailContentByType[moduleType] || detailContentByType['default'])()}</BasicForm>;
    }
}
export default FHEProductDetail;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/Fhe/index.js